import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, LogOut } from 'lucide-react';

const SearchBar = () => (
  <div style={{
    display: 'flex', alignItems: 'center', backgroundColor: '#F0EDF6',
    borderRadius: '20px', padding: '8px 16px', width: '280px'
  }}>
    <input
      type="text"
      placeholder="Search Here"
      style={{
        border: 'none', background: 'transparent', outline: 'none',
        flexGrow: 1, fontFamily: 'inherit', color: '#333333', fontSize: '14px'
      }}
    />
    <Search style={{ color: '#555555', cursor: 'pointer' }} size={18} />
  </div>
);

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userEmail');
    sessionStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <header style={{
      height: '60px', backgroundColor: '#FFFFFF', display: 'flex', alignItems: 'center',
      justifyContent: 'flex-start', borderBottom: '1px solid #E8E8E8',
      flexShrink: 0, width: '100%', boxSizing: 'border-box',
      padding: '0 24px',
    }}>
      {/* Search + Notifications + User */}
      <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'space-between', alignItems: 'center' }}>
        <SearchBar />

        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          <div
            onClick={handleLogout}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#dc2626', fontSize: '14px', cursor: 'pointer' }}
          >
            <LogOut size={18} />
            <span style={{ fontWeight: 500 }}>Logout</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
